import React from 'react';

import { ErrorBlock } from '@src/components/ErrorBlock';
import { ErrorImage } from '@src/components/ErrorImage';

import styles from './styles.module.scss';

function ServerError() {
    return (
        <div className={styles.page}>
            <ErrorImage imageSrc="https://www.sravni.ru/f/images/500.png" alt="500 Ошибка сервера" />
            <ErrorBlock />
        </div>
    );
}

export default ServerError;
